import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from 'config/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from 'components/Spinner/Spinner';
import './factio-button.css';

export const BUTTON_TYPES = {
    DEFAULT_SOLID_BRAND: 'dsb',
    DEFAULT_SOLID_BRAND_DARK: 'dsbd',
    SQUARE_SOLID_BRAND_DARK: 'ssbd',
    DEFAULT_HOLLOW_BRAND: 'dhb',
    DEFAULT_SOLID_ORANGE: 'dso',
    DEFAULT_HOLLOW_ORANGE: 'dho',
    DEFAULT_HOLLOW_BLACK: 'dhbl',
    DEFAULT_SOLID_RED: 'dsr',
    SQUARE_HOLLOW_BRAND: 'shb',
    DEFAULT_SOLID_WHITE: 'dsw',
    SQUARE_SOLID_WHITE: 'ssw',
    SQUARE_SOLID_RED: 'ssr',
    SQUARE_SOLID_BRAND: 'ssb',
    SQUARE_SOLID_ORANGE: 'sso',
    SQUARE_HOLLOW_ORANGE: 'sho',
    SQUARE_HOLLOW_RED: 'shr',
    SQUARE_HOLLOW_GRAY: 'shg',
    DEFAULT_SOLID_GRAY: 'dsg'
};

// NOTE: disabled prop is only for non-route buttons
class Button extends PureComponent {
    static propTypes = {
        isAuthed: PropTypes.bool.isRequired,
        isAuthRequired: PropTypes.bool,
        label: PropTypes.string,
        type: PropTypes.string,
        isLoading: PropTypes.bool,
        route: PropTypes.string,
        routeState: PropTypes.object,
        leftIcon: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        rightIcon: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        leftNode: PropTypes.any,
        rightNode: PropTypes.any,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        isInset: PropTypes.bool,
        className: PropTypes.string
    }

    static defaultProps = {
        label: '',
        disabled: false,
        isInset: false,
        isAuthRequired: false,
        className: ''
    }

    constructor(props) {
        super(props);

        this.IS_DEBOUNCE = false;
        this.DEBOUNCE_TIMEOUT = null;
        this.state = {
            route: props.isAuthRequired && !props.isAuthed
                ? ROUTE_PATHS.ONBOARDING
                : props.route
        };
    }

    componentWillUnmount() {
        clearTimeout(this.DEBOUNCE_TIMEOUT);
    }

    onClick = (e) => {
        if (!this.props.disabled && !this.props.isLoading) {
            if (this.IS_DEBOUNCE) {
                return;
            }

            this.IS_DEBOUNCE = true;

            this.props.onClick(e);

            this.DEBOUNCE_TIMEOUT = setTimeout(this.debounce, 600);
        }
    }

    debounce = () => {
        this.IS_DEBOUNCE = false;
    }

    render() {
        const classBtnType = this.props.type ? `btn-factio--${this.props.type}` : '';

        if (this.state.route) {
            return (
                <Link
                    className={`btn btn-factio ${classBtnType} ${this.props.isInset ? 'btn-factio--inset' : ''} ${this.props.className}`}
                    to={{
                        pathname: this.state.route,
                        state: this.props.routeState
                    }}>
                    <div className='btn-factio__content'>
                        {this.props.leftIcon
                            ? <div className='btn-factio__node-left'>
                                <FontAwesomeIcon icon={this.props.leftIcon} />
                            </div>
                            : this.props.leftNode
                                ? <div className='btn-factio__node-left'>
                                    {this.props.leftNode}
                                </div>
                                : null
                        }

                        {this.props.label}

                        {this.props.rightIcon
                            ? <div className='btn-factio__node-right'>
                                <FontAwesomeIcon icon={this.props.rightIcon} />
                            </div>
                            : this.props.rightNode
                                ? <div className='btn-factio__node-right'>
                                    {this.props.rightNode}
                                </div>
                                : null
                        }
                    </div>
                </Link>
            );
        }
        else {
            return (
                <div
                    className={`btn btn-factio ${classBtnType} ${this.props.disabled || this.props.isLoading ? 'btn-factio--disbaled' : ''} ${this.props.isInset ? 'btn-factio--inset' : ''} ${this.props.className}`}
                    onClick={this.onClick}>
                    <div className='btn-factio__content'>
                        {this.props.leftIcon
                            ? <div className='btn-factio__node-left'>
                                <FontAwesomeIcon icon={this.props.leftIcon} />
                            </div>
                            : this.props.leftNode
                                ? <div className='btn-factio__node-left'>
                                    {this.props.leftNode}
                                </div>
                                : null
                        }

                        {this.props.isLoading
                            ? <Spinner size={20} />
                            : this.props.label
                        }

                        {this.props.rightIcon
                            ? <div className='btn-factio__node-right'>
                                <FontAwesomeIcon icon={this.props.rightIcon} />
                            </div>
                            : this.props.rightNode
                                ? <div className='btn-factio__node-right'>
                                    {this.props.rightNode}
                                </div>
                                : null
                        }
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps({ authentication }) {
    return {
        isAuthed: authentication.isAuthed
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Button);
